import React from 'react'

const Location20pxSvg = (props) => {
    return (
        <svg 
        {...props}
        width="20" height="24.706" viewBox="0 0 20 24.706" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.553 10.152a9.471 9.471 0 0 0 -1.294 -4.824 9.494 9.494 0 0 0 -3.435 -3.435 9.471 9.471 0 0 0 -4.824 -1.294 9.471 9.471 0 0 0 -4.824 1.294 9.494 9.494 0 0 0 -3.435 3.435 9.471 9.471 0 0 0 -1.294 4.824q0 2.259 1.012 4.282a9.294 9.294 0 0 0 2.706 3.294l5.929 6.4 5.859 -6.494a9.765 9.765 0 0 0 2.612 -3.271q0.988 -1.976 0.988 -4.212m-9.529 -2.776q0.753 0 1.388 0.376t1.012 1.012 0.376 1.388 -0.376 1.4 -1.012 1.024 -1.388 0.376 -1.388 -0.376a2.824 2.824 0 0 1 -1.012 -1.024 2.706 2.706 0 0 1 -0.376 -1.4q0 -0.753 0.376 -1.4t1.012 -1.012 1.388 -0.365" fill="#A3A9B1"/></svg>


    )
}

export default Location20pxSvg